import "./DropdownButton.scss";

import React, { FC, useState } from "react";
import {
    FontAwesomeIcon,
    FontAwesomeIcons,
} from "src/constants/fontAwesomeIcons";
import OutsideClick from "../OutsideClick/OutsideClick";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import useNavigate from "src/hooks/useNavigate";

export interface IDropdownOption {
    url?: string;
    icon: IconDefinition;
    title: string;
}

interface IDropdownButtonProps {
    title: string;
    options: IDropdownOption[];
}

const DropdownButton: FC<IDropdownButtonProps> = ({ title, options }) => {
    //
    // -- States --
    const [isOpen, setIsOpen] = useState<boolean>(false);

    //
    // -- Hooks --
    const navigate = useNavigate();

    //
    // -- Methods --
    const handleClickOutside = (_event) => {
        setIsOpen(false);
    };

    const handleOnClickEvent: React.MouseEventHandler<HTMLButtonElement> = (
        _event
    ) => {
        setIsOpen(!isOpen);
    };

    const renderDropdownOptions = () => {
        return options?.map((item, index) => (
            <li
                key={`list-item-${item.title}-${index}`}
                onClick={() => (item.url ? navigate(item.url) : null)}
            >
                {item.title}
            </li>
        ));
    };

    return (
        <OutsideClick onOutsideClick={handleClickOutside}>
            <div className="custom-dropdown">
                <button
                    id="dropdownButton"
                    className="custom-dropdown-button"
                    onClick={handleOnClickEvent}
                    type="button"
                >
                    {title}
                    <div style={{ width: "0.8rem" }} />
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.CARETDOWN} />
                </button>
                {isOpen && (
                    <div
                        id="myDropdown"
                        className="custom-dropdown-content custom-show"
                    >
                        <ul className="custom-scrollbar">
                            {renderDropdownOptions()}
                        </ul>
                    </div>
                )}
            </div>
        </OutsideClick>
    );
};

export default DropdownButton;
